import _ from 'lodash'
// import { ProductForm } from '@shopify/theme-product-form'

const ACTIVE_CLASS = 'active'

class ProductFormElement extends HTMLElement {
  constructor () {
    super()


    if (this.dataset.variants) {
      this.variants = JSON.parse(this.dataset.variants)
    }
    this.productType = this.dataset.productType
    this.isGiftCard = this.productType === 'gift-card'
    this.listPlanOptions = this.querySelectorAll('.js-plan-option') || []
    this.buttonSubscribe = this.querySelector('.js-button-subscribe')

    this.contentTooltip = this.querySelector('.js-content-tooltip')
    this.toggleButtonEls = this.querySelectorAll('.js-trigger-tooltip')
    this.enablePurchase = this.dataset.purchase

    this.toggleTooltip(this.contentTooltip, this.toggleButtonEls)

    this.formEl = this.querySelector('form')

    this.formEl.addEventListener('change', (event) => {
      if (event.target.closest('[data-option]')) {
        this.onOptionChange(event)
      }
      if (this.buttonSubscribe) {
        this.checkHasOptionSelected(event)
      }
    })

    this.formEl.addEventListener('submit', (event) => {
      event.preventDefault()
    })

    const afterpayModalEls = document.querySelectorAll('afterpay-modal')
    afterpayModalEls.length && afterpayModalEls.forEach(modal => {
      const style = document.createElement('style')
      style.innerHTML = `
        .afterpay-modal-logo path {
          fill: #000000;
        }
        .afterpay-modal-logo g path {
          fill: #ffffff;
        }
        .afterpay-loading-indicator::after {
          border-color: #ffffff transparent #ffffff transparent;
        }
      `
      modal.shadowRoot.appendChild(style)
    })
  }

  addToCartOneTimePurchased (event) {
    event.stopPropagation()
  }

  onOptionChange (event) {
    const formEl = this.querySelector('form')

    const option1 = formEl.querySelector('[data-option="1"] input[type="radio"]:checked')
    const option2 = formEl.querySelector('[data-option="2"] input[type="radio"]:checked')
    const option3 = formEl.querySelector('[data-option="3"] input[type="radio"]:checked')

    let matchingVariant = _.find(this.variants, {
      option1: option1?.value || null,
      option2: option2?.value || null,
      option3: option3?.value || null
    })

    if (this.isGiftCard) {
      const optionValue = formEl.querySelector('[data-option="1"] select')

      matchingVariant = _.find(this.variants, {
        option1: optionValue?.value || null
      })
    }

    this.querySelector('input[name="id"]').value = matchingVariant.id
    this.updateCurrentOptionName(event, matchingVariant)

    this.dispatchEvent(new CustomEvent('change-variant', {
      detail: {
        id: matchingVariant.id,
        mediaId: matchingVariant.featured_media && matchingVariant.featured_media.id ? matchingVariant.featured_media.id : ''
      },
      bubbles: true
    }))
  }

  updateCurrentOptionName (event, variant) {
    const optionEl = event.target.closest('[data-option]')
    const optionNameEl = optionEl ? optionEl.querySelector('.js-option-name') : ''
    if (optionNameEl) {
      const optionName = 'option' + optionEl.dataset.option
      optionNameEl.innerHTML = variant[optionName]
    }
  }

  triggerOneTimePurchase(event) {
    const body = document.body
    const widgetSubcription = this.querySelector('.js-widget-subscription')
    const inputOneTime = widgetSubcription.querySelector('input#selling_plan_onetime')
    const inputPlanEls = widgetSubcription.querySelectorAll('input[name="selling_plan"]:not(#selling_plan_onetime)')
    const sellingPlanEl = this.querySelector('.js-selling-plan')
    const buttonOneItem = this.querySelector('.js-button-one-item')

    if (event.target.value === 'one-time-purchase' && !inputOneTime.checked) {
      inputOneTime.checked = true
      body.classList.remove('is-subscription')
      if (sellingPlanEl) sellingPlanEl.style.display = 'none'
      if (buttonOneItem) buttonOneItem.style.display = 'block'
      if (this.buttonSubscribe) this.buttonSubscribe.style.display = 'none'
    } else {
      const dataStorage = localStorage.getItem('selling_plan')
      const inputPlanSelected = Array.prototype.slice.call(inputPlanEls).find((item) => item.value === dataStorage)
      if (sellingPlanEl) sellingPlanEl.style.display = 'block'
      if (buttonOneItem) buttonOneItem.style.display = 'none'
      if (this.buttonSubscribe) this.buttonSubscribe.style.display = 'block'

      if (dataStorage && inputPlanSelected) {
        inputPlanSelected.checked = true
        inputPlanSelected.click()
      } else {
        inputPlanEls[0].checked = true
        inputPlanEls[0].click()
      }

      body.classList.add('is-subscription')
    }
  }

  setValueStorageWithPlanValue (event) {
    if (event.target && event.target.value) {
      localStorage.setItem('selling_plan', event.target.value)
    }
  }

  checkHasOptionSelected (event) {
    const inRecharge = event.target.closest('.js-radio-wrapper')
    const listPlans = event.target.closest('.js-list-plan')

    if (inRecharge) {
      this.triggerOneTimePurchase(event)
    }

    if (listPlans) {
      this.setValueStorageWithPlanValue(event)
    }

    const hasOptionChecked = Array.from(this.listPlanOptions).some(option => option.checked)
    if (!hasOptionChecked && this.buttonSubscribe) {
      this.buttonSubscribe.setAttribute('disabled', true)
    } else {
      this.buttonSubscribe.removeAttribute('disabled')
    }
  }

  toggleTooltip (content, buttons) {
    if (content && buttons.length) {
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          content.classList.toggle(ACTIVE_CLASS)
        })
      })
    }
  }
}

customElements.define('product-form', ProductFormElement)
